import { ReportFunction } from '../api/enumerations';

export const REPORT_FUNCTION_OPTIONS: ReportFunction[] = [
  ReportFunction.TENANCY,
  ReportFunction.LEASE,
  ReportFunction.LENDING,
  ReportFunction.ACQUISITION,
  ReportFunction.DONATION,
  ReportFunction.ALIENATION,
  ReportFunction.GIVING_PAYMENT,
  ReportFunction.EXCHANGE,
  ReportFunction.GUARANTEE,
  ReportFunction.ACCOUNTING,
  ReportFunction.INSURANCE,
  ReportFunction.AUCTION,
  ReportFunction.ADJUDICATION,
  ReportFunction.REPARATION,
  ReportFunction.TAXATION,
  ReportFunction.JUDICIAL,
  ReportFunction.EXTRA_JUDICIAL,
  ReportFunction.PRE_AUCTION,
  ReportFunction.OTHERS,
];
